import { ChangeDetectionStrategy, Component, computed, inject, input, Signal } from '@angular/core';
import { UrlService, UtilityService } from '@eforall/common';
import { DialogService, GridContentWidget, PageTabsLayout, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { Commitment } from '@interfaces';
import { TrimesterService } from '../../../../services';
import { getSetup } from './grid/get-setup';

interface CommitmentsGridServiceInterface {
	layout: Signal<PageTabsLayout | undefined>
}

@Component({
	selector: 'commitments-grid',
	standalone: true,
	imports: [GridContentWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './commitments-grid.part.html',
})
export class CommitmentsGridPart {

	public service = input.required<CommitmentsGridServiceInterface>();
	public rows = input.required<Commitment[]>();

	public readonly dialogService = inject(DialogService);
	public readonly urlService = inject(UrlService);
	private readonly util = inject(UtilityService);
	private readonly trimesterService = inject(TrimesterService);

	public commitments = computed<Commitment[]>(() => {
		const trimesters = this.trimesterService.allTrimesterData();
		const selectedTrimester = this.trimesterService.selectedTrimester();

		// get the endTrimesterId based on startTrimesterId and numsTrimester
		const commitments: Commitment[] = this.rows();

		if (!selectedTrimester) return commitments;

		// filter the commitments which overlap with the selected trimester
		return commitments.filter(c => c.endTrimesterId ? c.endTrimesterId >= selectedTrimester.trimesterId : true)
	});

	public setup = computed(() => {
		const currentPage = this.urlService.url().split('/')[1] ?? '';
		return getSetup(
			this.util,
			this.dialogService,
			currentPage
		);
	});

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		const layout = this.service().layout();
		if (layout) {
			return { layout: layout, viewSelector: true };
		}
		return undefined;
	});

}
